
import axiosClient from "./axiosClient";

const PREFIX_URL = "crm/tai-khoan";

const userApi = {
    getFilter: (params) => {
        const url = `${PREFIX_URL}/index`;
        return axiosClient.get(url, { params });
    },
    getUserInfo: (params = {}) => {
        const url = `${PREFIX_URL}/getUserInfo`;
        return axiosClient.get(url, { params });
    },
    getUserProfile: (params = {}) => {
        const url = `${PREFIX_URL}/getUserProfile`;
        return axiosClient.get(url, { params });
    },
    getUserManager: (params = {}) => {
        const url = `${PREFIX_URL}/getUserManager`;
        return axiosClient.get(url, { params });
    },
    getOrganizations: (params = {}) => {
        const url = `${PREFIX_URL}/listOrganization`;
        return axiosClient.get(url, { params });
    },
    getById: (params) => {
        const url = `${PREFIX_URL}/getById`;
        return axiosClient.get(url, { params });
    },
    create: (params) => {
        const url = `${PREFIX_URL}/create`;
        return axiosClient.post(url, params);
    },
    update: (params) => {
        const url = `${PREFIX_URL}/update`;
        return axiosClient.post(url, params);
    },
    active: (params) => {
        const url = `${PREFIX_URL}/active`;
        return axiosClient.get(url, { params });
    },
    lock: (data) => {
        const url = `${PREFIX_URL}/lock`;
        return axiosClient.post(url, data );
    },
    getAllByType: (data) => {
        const url = `${PREFIX_URL}/getAllUserByType`;
        return axiosClient.post(url, data );
    },
    updateCurrent: (data) => {
        const url = `${PREFIX_URL}/updateCurrent`;
        return axiosClient.post(url, data);
    },
    getAllUserByAgency: (data) => {
        const url = `${PREFIX_URL}/getAllUserByAgency`;
        return axiosClient.post(url, data);
    },
    assignCapacity: (params) => {
        const url = `${PREFIX_URL}/assignCapacity`;
        return axiosClient.get(url, { params });
    },
    getAllUserInCompany: (params) => {
        const url = `${PREFIX_URL}/getAllUserInCompany`;
        return axiosClient.get(url, { params });
    },
    getUserInfoById: (params) => {
        const url = `${PREFIX_URL}/getUserInfoById`;
        return axiosClient.get(url, { params });
    },
    getCurrent: (params) => {
        const url = `${PREFIX_URL}/getCurrent`;
        return axiosClient.get(url, { params });
    },
    changeOrganization: (params) => {
        const url = `${PREFIX_URL}/changeOrganization`;
        return axiosClient.post(url, params);
    },
    getLinkIframeID: (params) => {
        const url = `${PREFIX_URL}/getLinkIframeID`;
        return axiosClient.get(url, { params });
    },
    approveAcc: (params) => {
        const url = `${PREFIX_URL}/approveAcc`;
        return axiosClient.post(url, params);
    },
    refuseAcc: (params) => {
        const url = `${PREFIX_URL}/refuseAcc`;
        return axiosClient.post(url, params);
    },

}

export default userApi;
